import { AfterViewInit, Component, Input, ViewChild, ContentChildren, Renderer2, QueryList, ElementRef, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { OverlayRef, ConnectedPosition, ScrollStrategy, ScrollStrategyOptions, CdkOverlayOrigin } from "@angular/cdk/overlay";
import { ValgButtonDirective } from '../input/button/button.directive';

let OVERFLOW_MENU_ID = 0;

export interface OverflowMenuItem<T> {
  title: string;
  action: (item: T) => void;
  filter?: (item: T) =>  boolean;
}

@Component({
  selector: 'valg-overflow-menu',
  templateUrl: './overflow-menu.component.html'
})
export class OverflowMenuComponent implements AfterViewInit {
  public id = `valg-overflow-menu-${OVERFLOW_MENU_ID++}`;
  isOpen = false;

  @Input() origin!: CdkOverlayOrigin;
  @Input() position: 'below' | 'above' = 'below';
  @Input() originLabel!: string;

  @ViewChild('overlay') overlay!: OverlayRef;
  @ContentChildren(ValgButtonDirective, {read: ElementRef}) public buttons!: QueryList<ElementRef>;

  scrollStrategy: ScrollStrategy;

  private belowPosition = {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    panelClass: 'valg-overflow-menu-overlay__below',
    offsetY: 16,
    offsetX: -14
  } as ConnectedPosition;

  private abovePosition = {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    panelClass: 'valg-overflow-menu-overlay__above',
    offsetY: -16,
    offsetX: -12
  } as ConnectedPosition;

  overlayConnectedPositions: ConnectedPosition[] = [
    this.belowPosition,
    this.abovePosition
  ];

  public clickedListener!: () => void;

  constructor(
      protected translate: TranslateService,
      protected readonly _sso: ScrollStrategyOptions,
      private renderer: Renderer2,
      private readonly cdr: ChangeDetectorRef
  ){
    this.scrollStrategy = _sso.reposition();
  }

  public ngAfterViewInit (): void {
    if(this.position === 'above'){
      // @ts-ignore
      this.overlayConnectedPositions = this.overlayConnectedPositions.reverse();
    }

    this.renderer.listen(this.origin.elementRef.nativeElement, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.onTab(event);
      }
    });
  }

  onTab(event: Event){
    if(this.isOpen){
      if(this.buttons.length > 0){
        event.preventDefault();
        const menuButtons = this.buttons.filter(x => x.nativeElement.tabIndex !== -1);
        if (menuButtons.length > 0) {
          menuButtons[0].nativeElement.focus();
        }
      }
    }
  }

  public close(target: HTMLButtonElement | undefined = undefined){
    if(this.clickedListener){
      this.clickedListener();
    }
    this.isOpen = false;
    if (!target || !target.attributes.getNamedItem(this.originLabel)) {
      this.origin.elementRef.nativeElement.focus();
    }
  }

  public open(){
    if(this.clickedListener){
      this.clickedListener();
    }
    this.clickedListener = this.renderer.listen('document', 'click', (evt) => {
      let target = evt.target as HTMLButtonElement;
      let found = this.buttons.find(element => element.nativeElement === target);
      if(!found && target !== this.origin.elementRef.nativeElement){
        this.close(target);
        this.cdr.detectChanges();
      }
    });
    this.isOpen = true;
    this.origin.elementRef.nativeElement.focus();
  }

  onClose(){
    if(this.isOpen){
      this.close();
    }
  }
}
